// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'زبان خود را انتخاب کنید',
    },
    MENU: {
      NEW: 'جدید',
      ACTIONS: 'Actions',
      CREATE_POST: 'پست جدید',
      PAGES: 'صفحه ها',
      FEATURES: 'Features',
      APPS: 'برنامه ها',
      DASHBOARD: 'داشبورد',
    },
    AUTH: {
      GENERAL: {
        OR: 'یا',
        SUBMIT_BUTTON: 'تایید',
        NO_ACCOUNT: 'ساخت اکانت جدید',
        SIGNUP_BUTTON: 'ثبت نام',
        FORGOT_BUTTON: 'فراموشی رمز عبور',
        BACK_BUTTON: 'بازگشت',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'ورود به ناحیه کاربری',
        BUTTON: 'ورود',
      },
      FORGOT: {
        TITLE: 'آیا رمز عبور خود را فراموش کرده اید ؟',
        DESC: 'ایمیل خود را برای بازیابی رمز عبور وارد نمایدد',
        SUCCESS: 'رمز  کاربری شما با موفقیت بازیابی گردید'
      },
      REGISTER: {
        TITLE: 'ثبت نام',
        DESC: 'لطفا اطلاعات خود را وارد نمایید',
        SUCCESS: 'ثبت نام شما با موفقیت انجام شد '
      },
      INPUT: {
        EMAIL: 'آدرس ایمل ',
        FULLNAME: 'نام کامل',
        PASSWORD: 'رمز عبور',
        CONFIRM_PASSWORD: 'تکرار رمز عبور',
        USERNAME: 'نام کاربری'
      },
      VALIDATION: {
        INVALID: '{{name}} معتبر نیست ',
        REQUIRED: '{{name}} واجب است',
        MIN_LENGTH: '{{name}} حداقل بای  {{min}} کاراکتر باشد',
        AGREEMENT_REQUIRED: 'لطفا قوانین را تایید نمایید',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'اطلاعات وارد شده معتبر نمیباشد',
        REQUIRED_FIELD: 'فیلد اجباری',
        MIN_LENGTH_FIELD: 'حداقال کاراکتر مورد تایید :',
        MAX_LENGTH_FIELD: 'حداکثر کاراکتر مورد تایید : ',
        INVALID_FIELD: 'فیلد وارد شده نامعتبر است ',
      }
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'تعداد رکورد انتخابی : ',
        ALL: 'همه',
        SUSPENDED: 'غیر فعال',
        ACTIVE: 'فعال',
        FILTER: 'فیلتر',
        BY_STATUS: 'بر اساس وضعیت',
        BY_TYPE: 'بر اساس نوع',
        BUSINESS: 'تجاری',
        INDIVIDUAL: 'شخصی',
        SEARCH: 'جستجو',
        IN_ALL_FIELDS: 'در تمام فیلد ها'
      },
      ECOMMERCE: 'فروشگاه',
      CUSTOMERS: {
        CUSTOMERS: 'Customers',
        CUSTOMERS_LIST: 'Customers list',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created'
        }
      }
    }
  }
};
